module.exports = __webpack_public_path__ + "66bd1c06e107464e3d19dbb4f544ea2c.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/FixedDirectionalityOFF.mp4
// module id = 394
// module chunks = 0